import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function BankAccountSelect({ banks, value, onChange, onCreated, canManage }) {
  const [adding, setAdding] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: "", aliases: "", currency: "MYR" });
  const activeBanks = banks.filter((bank) => bank.active).filter((bank, index, rows) =>
    rows.findIndex((candidate) => candidate.name.trim().toLowerCase() === bank.name.trim().toLowerCase()) === index);
  const save = async () => {
    if (!form.name.trim()) return toast.error("Bank account name is required");
    setSaving(true);
    try {
      const { data } = await api.post("/sales/banks", {
        name: form.name.trim(), currency: form.currency.trim().toUpperCase() || "MYR",
        aliases: form.aliases.split(",").map((item) => item.trim()).filter(Boolean),
      });
      toast.success(`${data.name} added`); onCreated?.(data); onChange(data.id);
      setForm({ name: "", aliases: "", currency: "MYR" }); setAdding(false);
    } catch (error) { toast.error(apiError(error)); }
    finally { setSaving(false); }
  };
  return <div className="space-y-2">
    <Label>Bank account</Label>
    <div className="flex gap-2">
      <Select value={value} onValueChange={onChange}><SelectTrigger className="flex-1"><SelectValue placeholder="Select bank" /></SelectTrigger><SelectContent>{activeBanks.map((bank) => <SelectItem key={bank.id} value={bank.id}>{bank.name} · {bank.currency || "MYR"}</SelectItem>)}</SelectContent></Select>
      {canManage && <Button type="button" variant="outline" onClick={() => setAdding(!adding)}>{adding ? "Cancel" : "+ Add bank"}</Button>}
    </div>
    {adding && <div className="grid sm:grid-cols-4 gap-2 rounded-sm border bg-slate-50 p-3">
      <Input placeholder="Bank / account name" value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} />
      <Input placeholder="Aliases, comma separated" value={form.aliases} onChange={(event) => setForm({ ...form, aliases: event.target.value })} />
      <Input placeholder="Currency" value={form.currency} onChange={(event) => setForm({ ...form, currency: event.target.value })} />
      <Button onClick={save} disabled={saving}>{saving ? "Adding..." : "Add bank account"}</Button>
    </div>}
  </div>;
}
